// Copyright 2017 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { ObjectExtensions } from "extensions/ObjectExtensions";
import { SoramaPortalDb } from "libraries/IndexedDb/SoramaPortalDb";
import { GenericIndexedDBRepository } from "repositories/GenericRepository";
import { MeasurementDeviceSetupStub } from "services/Hardware/Datatypes/MeasurementDeviceSetup";

@autoinject
export class MeasurementSetupRepository extends GenericIndexedDBRepository<MeasurementDeviceSetupStub> {
    constructor(soramaPortalDb: SoramaPortalDb) {
        super(soramaPortalDb, SoramaPortalDb.MeasurementDeviceSetupStoreName);
    }

    protected fromDatabase(databaseMeasurementDeviceSetup: MeasurementDeviceSetupStub): MeasurementDeviceSetupStub {
        return <MeasurementDeviceSetupStub>ObjectExtensions.copy(databaseMeasurementDeviceSetup);
    }
}
